import { render } from "./achievementDetails.vue?vue&type=template&id=43e36431&scoped=true"
import script from "./achievementDetails.vue?vue&type=script&lang=js"
export * from "./achievementDetails.vue?vue&type=script&lang=js"

import "./achievementDetails.vue?vue&type=style&index=0&id=43e36431&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e36431"]])

export default __exports__